import { SHIPPER_GUIDE_API_URL } from '../environment'
import { HttpClient } from './HttpClient'

export class ShipperGuideClient extends HttpClient {
  constructor() {
    super(SHIPPER_GUIDE_API_URL, { requestInterceptor: null, responseInterceptor: null })
  }
}
